import { http, HttpHandler, HttpResponse } from 'msw';
import { projectDetailsMock } from '../../../api';

// This request is only used during tests since you need a valid token to use daily
export const mocks = {
  details: http.get('*/v1/public/projects/:project_uuid/details', () =>
    HttpResponse.json(projectDetailsMock, { status: 200 }),
  ),
} satisfies Record<PropertyKey, HttpHandler>;
